import { extractMustacheVariables, recalculateStyles } from '~core/templates';
/**
 * Process canvas objects to adjust styles based on variable values
 * @param {string} canvasJson - Canvas JSON string
 * @param {Object} context - Context with variable values
 * @returns {string} - Processed canvas JSON string
 */
export default function processCanvasObjects(canvasJson, context) {
  try {
    const canvas = JSON.parse(canvasJson);

    if (!canvas.objects || !Array.isArray(canvas.objects)) {
      return canvasJson;
    }

    canvas.objects = canvas.objects.map((obj) => {
      // Only process textbox objects
      if (obj.type === 'textbox' && obj.text) {
        // Extract variables
        const variables = extractMustacheVariables(obj.text);
        if (variables.length > 0) {
          // Recalculate styles with original text
          obj.styles = recalculateStyles(
            obj.styles,
            variables,
            context,
            obj.text
          );
        }
      }
      return obj;
    });

    return JSON.stringify(canvas);
  } catch (err) {
    console.error(
      'Error processing canvas objects for style recalculation:',
      err
    );
    return canvasJson;
  }
}
